import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store/index'

// 解决报错
const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace
// push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
    return originalPush.call(this, location).catch((err) => err)
}
// replace
VueRouter.prototype.replace = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
    return originalReplace.call(this, location).catch((err) => err)
}
Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'index',
        component: () => import('../views/index.vue'),
        meta: {
            title: '弗顿',
        },
    },
    {
        path: '/quick-order',
        name: 'quick-order',
        component: () => import('../views/products/quick-order.vue'),
        meta: {
            title: '快速订购',
        },
    },
    {
        path: '/file-search',
        name: 'file-search',
        component: () => import('../views/file/file-search.vue'),
        meta: {
            title: '文件',
        },
    },
    {
        path: '/search',
        name: 'search',
        component: () => import('../views/search/search.vue'),
        meta: {
            title: '高级检索',
        },
    },
    {
        path: '/search-result',
        name: 'search-result',
        component: () => import('../views/search/search-result.vue'),
        meta: {
            title: '搜索结果',
        },
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('../views/login/login.vue'),
        meta: {
            title: '登录',
        },
    },
    {
        path: '/forgot-password',
        name: 'forgot-password',
        component: () => import('../views/login/forgot-password.vue'),
        meta: {
            title: '忘记密码',
        },
    },
    {
        path: '/register',
        name: 'register',
        component: () => import('../views/login/register.vue'),
        meta: {
            title: '注册',
        },
    },
    {
        path: '/register-relevance',
        name: 'register-relevance',
        component: () => import('../views/login/register-relevance.vue'),
        meta: {
            title: '注册',
        },
    },
    {
        path: '/register-step1',
        name: 'register-step1',
        component: () => import('../views/login/register-step1.vue'),
        meta: {
            title: '关联贵公司',
        },
    },
    {
        path: '/register-step2',
        name: 'register-step2',
        component: () => import('../views/login/register-step2.vue'),
        meta: {
            title: '关联贵公司',
        },
    },
    {
        path: '/register-step3',
        name: 'register-step3',
        component: () => import('../views/login/register-step3.vue'),
        meta: {
            title: '关联贵公司',
        },
    },
    {
        path: '/products',
        name: 'products',
        component: () => import('../views/products/products.vue'),
        meta: {
            title: '产品',
        },
    },
    {
        path: '/product-detail',
        name: 'product-detail',
        component: () => import('../views/products/product-detail.vue'),
        meta: {
            title: '产品详情',
        },
    },
    {
        path: '/cart',
        name: 'cart',
        component: () => import('../views/products/cart.vue'),
        meta: {
            title: '购物车',
        },
    },
    {
        path: '/cart-pay',
        name: 'cart-pay',
        component: () => import('../views/products/cart-pay.vue'),
        meta: {
            title: '结算',
        },
    },
    {
        path: '/cart-pay-quotes',
        name: 'cart-pay-quotes',
        component: () => import('../views/products/cart-pay-quotes.vue'),
        meta: {
            title: '报价单结算',
        },
    },
    {
        path: '/cart-get',
        name: 'cart-get',
        component: () => import('../views/products/cart-get.vue'),
        meta: {
            title: '购物车',
        },
    },
    {
        path: '/compare',
        name: 'compare',
        component: () => import('../views/products/compare.vue'),
        meta: {
            title: '比较',
        },
    },
    {
        path: '/mine',
        name: 'mine',
        component: () => import('../views/mine/mine.vue'),
        meta: {
            title: '个人资料',
        },
    },
    {
        path: '/mine-detail',
        name: 'mine-detail',
        component: () => import('../views/mine/mine-detail.vue'),
        meta: {
            title: '个人信息',
        },
    },
    {
        path: '/mine-detail-edit',
        name: 'mine-detail-edit',
        component: () => import('../views/mine/mine-detail-edit.vue'),
        meta: {
            title: '订购人信息',
        },
    },
    {
        path: '/change-password',
        name: 'change-password',
        component: () => import('../views/mine/change-password.vue'),
        meta: {
            title: '更改密码',
        },
    },
    {
        path: '/address-book',
        name: 'address-book',
        component: () => import('../views/mine/address-book.vue'),
        meta: {
            title: '地址簿',
        },
    },
    {
        path: '/mailing-address',
        name: 'mailing-address',
        component: () => import('../views/mine/mailing-address.vue'),
        meta: {
            title: '邮寄地址',
        },
    },
    {
        path: '/shipping-address',
        name: 'shipping-address',
        component: () => import('../views/mine/shipping-address.vue'),
        meta: {
            title: '收货地址',
        },
    },
    {
        path: '/billing-address',
        name: 'billing-address',
        component: () => import('../views/mine/billing-address.vue'),
        meta: {
            title: '开票地址',
        },
    },
    {
        path: '/site-preferences',
        name: 'site-preferences',
        component: () => import('../views/mine/site-preferences.vue'),
        meta: {
            title: '站点设置',
        },
    },
    {
        path: '/email-preferences',
        name: 'email-preferences',
        component: () => import('../views/mine/email-preferences.vue'),
        meta: {
            title: '电子邮件首选项',
        },
    },
    {
        path: '/payment-methods',
        name: 'payment-methods',
        component: () => import('../views/mine/payment-methods.vue'),
        meta: {
            title: '付款方式',
        },
    },
    {
        path: '/invite-coworker',
        name: 'invite-coworker',
        component: () => import('../views/mine/invite-coworker.vue'),
        meta: {
            title: '邀请同事',
        },
    },
    {
        path: '/quotes-detail',
        component: () => import('../views/mine/order-center/quotes-detail.vue'),
        meta: {
            title: '报价详情',
        },
    },
    {
        path: '/saved-carts-detail',
        component: () => import('../views/mine/order-center/saved-carts-detail.vue'),
        meta: {
            title: '已保存购物车',
        },
    },
    {
        path: '/lists-detail',
        component: () => import('../views/mine/order-center/lists-detail.vue'),
        meta: {
            title: '清单详情',
        },
    },
    {
        path: '/orders',
        component: () => import('../views/mine/order-center/orders.vue'),
        meta: {
            title: '订单详情',
        },
    },
    {
        path: '/documents-search',
        component: () => import('../views/mine/order-center/documents-search.vue'),
        meta: {
            title: '文档库',
        },
    },
    // 服务
    {
        path: '/services/support/bulk-quotation-request',
        name: 'bulk-quotation-request',
        component: () => import('../views/services/bulk-quotation-request.vue'),
        meta: {
            title: '获取大包装/定制包装报价',
        },
    },
    {
        path: '/services/:enName',
        name: 'services',
        component: () => import('../views/services/services.vue'),
        meta: {
            title: '服务',
        },
    },
    {
        path: '/services/:enName/:enName2',
        name: 'services2',
        component: () => import('../views/services/services2.vue'),
        meta: {
            title: '服务',
        },
    },
    {
        path: '/services-detail/:enName',
        name: 'servicesDetail',
        component: () => import('../views/services/services-detail.vue'),
        meta: {
            title: '服务详情',
        },
    },
    {
        path: '/services-list',
        component: () => import('../views/services/services-list.vue'),
        meta: {
            title: '服务',
        },
    },

    // 个人中心
    {
        path: '/order-center',
        name: 'order-center',
        component: () => import('../views/mine/order-center/order-center.vue'),
        children: [
            {
                path: '/account',
                component: () => import('../views/mine/order-center/account.vue'),
                meta: {
                    title: '个人资料',
                },
            },
            {
                path: '/order-search',
                component: () => import('../views/mine/order-center/order-search.vue'),
                meta: {
                    title: '订购中心',
                },
            },
            {
                path: '/quotes',
                component: () => import('../views/mine/order-center/quotes.vue'),
                meta: {
                    title: '报价',
                },
            },
            {
                path: '/buy-it-again',
                component: () => import('../views/mine/order-center/buy-it-again.vue'),
                meta: {
                    title: '再次购买',
                },
            },
            {
                path: '/saved-carts',
                component: () => import('../views/mine/order-center/saved-carts.vue'),
                meta: {
                    title: '已保存购物车',
                },
            },
            {
                path: '/fapiao-search',
                component: () => import('../views/mine/order-center/fapiao-search.vue'),
                meta: {
                    title: '发票列表',
                },
            },
            {
                path: '/lists',
                component: () => import('../views/mine/order-center/lists.vue'),
                meta: {
                    title: '清单',
                },
            },
        ],
    },
    //应用
    {
        path: '/applications/:enName',
        name: 'applications',
        component: () => import('../views/applications/applications.vue'),
        meta: {
            title: '应用',
        },
    },
    {
        path: '/applications/:enName/:enName2',
        name: 'applications2',
        component: () => import('../views/applications/applications2.vue'),
        meta: {
            title: '应用',
        },
    },
    {
        path: '/applications-detail/:enName',
        name: 'applicationsDetail',
        component: () => import('../views/applications/applications-detail.vue'),
        meta: {
            title: '应用详情',
        },
    },
    // 支持-新
    {
        path: '/support/customer-support',
        component: () => import('@/views/support-new/support.vue'),
        children: [
            {
                name: 'support',
                path: ':enName',
                component: () => import('@/views/support-new/support-detail.vue'),
            },
        ],
    },
    // 责任
    {
        path: '/life-science',
        component: () => import('@/views/life-science/life-science.vue'),
        // children: [
        //     {
        //         name: 'life-science-detail',
        //         path: ':enName',
        //         component: () => import('@/views/support-new/support-detail.vue'),
        //     },
        // ],
    },
    // 活动
    {
        path: '/events',
        component: () => import('@/views/events/events.vue'),
        meta: {
            title: '活动',
        },
    },
    {
        path: '/eventsDetail',
        component: () => import('@/views/events/eventsDetail.vue'),
        meta: {
            title: '活动详情',
        },
    },
    // 新闻稿
    {
        path: '/news',
        component: () => import('@/views/news/news.vue'),
        meta: {
            title: '新闻稿',
        },
    },
    {
        path: '/news-detail',
        component: () => import('@/views/news/news-detail.vue'),
        meta: {
            title: '新闻稿详情',
        },
    },
    // 支持
    // {
    //     path: '/support',
    //     name: 'support',
    //     component: () => import('../views/support/support.vue'),
    //     children: [
    //         {
    //             path: '/faq',
    //             component: () => import('../views/support/faq.vue'),
    //         },
    //         {
    //             path: '/web-training',
    //             component: () => import('../views/support/web-training.vue'),
    //         },

    //         {
    //             path: '/ordering-information',
    //             component: () => import('../views/support/ordering-information.vue'),
    //         },
    //         {
    //             path: '/after-sales',
    //             component: () => import('../views/support/after-sales.vue'),
    //         },
    //         {
    //             path: '/wechat-customer-self-service',
    //             component: () => import('../views/support/wechat-customer-self-service.vue'),
    //         },
    //         {
    //             path: '/website-consolidation',
    //             component: () => import('../views/support/website-consolidation.vue'),
    //         },
    //         {
    //             path: '/process-solution',
    //             component: () => import('../views/support/process-solution.vue'),
    //         },
    //     ],
    // },
    {
        path: '/shipping-restriction-notice',
        component: () => import('../views/support/shipping-restriction-notice.vue'),
        meta: {
            title: '运输受限通知',
        },
    },
    // 关于我们
    {
        path: '/about',
        component: () => import('../views/about/about.vue'),
        meta: {
            title: '关于我们',
        },
    },
    {
        path: '/story-list',
        component: () => import('../views/about/story-list.vue'),
        meta: {
            title: '故事库',
        },
    },
    {
        path: '/story-detail',
        component: () => import('../views/about/story-detail.vue'),
        meta: {
            title: '故事详情',
        },
    },
    // 文章落地页
    {
        path: '/article/:name',
        name: 'article',
        component: () => import('@/views/article/article.vue'),
        meta: {
            title: '文章',
        },
    },
    {
        path: '/page/:pageKey',
        name: 'site-page',
        component: () => import('@/views/page/page.vue'),
        meta: {
            title: '单页',
        },
    },
    // 论文落地页
    {
        path: '/paper',
        name: 'paper',
        component: () => import('@/views/article/paper.vue'),
        meta: {
            title: '论文',
        },
    },
    // 报错页面
    {
        path: '/reportError',
        name: 'reportError',
        component: () => import('@/views/reportError/reportError.vue'),
        meta: {
            title: '技术支持',
        },
    },

    // 邮箱验证
    {
        path: '/emailCheck',
        name: 'emailCheck',
        component: () => import('@/views/emailCheck/emailCheck.vue'),
        meta: {
            title: '正在验证中',
        },
    },

    // 品牌
    {
        path: '/brand',
        name: 'brand',
        component: () => import('@/views/brand/brand.vue'),
        meta: {
            title: '品牌',
        },
    },

    {
        path: '*',
        redirect: '/',
    },
]

const router = new VueRouter({
    mode: 'history',
    base: '/',
    routes,
})

router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title
    } else {
        document.title = '弗顿'
    }
    // 关闭购物车弹窗
    store.commit('set_vuex_data', {
        k: 'vuex_cartWin',
        v: false,
    })
    // 关闭快速订购弹窗
    store.commit('set_vuex_data', {
        k: 'vuex_quick_win',
        v: false,
    })
    next()
    window.scrollTo({
        top: 0,
        behavior: 'smooth',
    })
})

export default router
